<script setup lang="ts">
import type {
  FieldConfigInterface,
  SliceInterface,
} from '@voix/types'

import type { PropType } from 'vue'

import GlobalField from './GlobalField.vue'

const props = defineProps({
  element: {
    type: Object as PropType<SliceInterface>,
    required: true,
  },

  group: {
    type: Object as PropType<Record<string, FieldConfigInterface>>,
    default: null,
  },
})

// this is reproducing the logic from adminStore: selectedFieldData() getter
// that is used when a single field is selected
function calculateFieldData(fieldName: string, field: any) {
  if (props.element && field.type) {
    // We are looking into the data of the selected slice
    // to try and find any existing data for the field the user
    // has selected. It may not be there because the developer
    // may have added a field to the slice after the slice was
    // added to the page or it may be a new slice that was just
    // added to the page.
    const foundField = props.element.fields?.find(
      (f: any) => f.name === fieldName,
    )

    return foundField
  }
  return null
}
</script>

<template>
  <div v-if="Object.keys(group).length > 0" class="space-y-4">
    <GlobalField
      v-for="(field, fieldName) in group"
      :key="fieldName"
      :element="element"
      :field-data="calculateFieldData(fieldName, field)"
      :field-configuration="field"
    />
  </div>
</template>
